/**
 * EmailSmtpSettingsPage — SMTP beállítások admin UI
 * Story 2.3: SMTP beállítások admin UI
 *
 * ⚠️ ELŐNÉZET: sem a mentés, sem a kapcsolat-teszt nincs backendhez kötve.
 * A korábbi setTimeout-os "siker" és "kapcsolat OK" HAZUG visszajelzés volt
 * (🧭 mérése, 2026-09-09) — a gomb tiltva, a teszt-gomb eltávolítva, amíg a
 * PUT/POST /settings/email-config végpont meg nem épül.
 */

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { useTranslation } from '@kgc/i18n';
import { useState } from 'react';

export function EmailSmtpSettingsPage() {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    smtpHost: '',
    smtpPort: '587',
    smtpUser: '',
    smtpPass: '',
    senderEmail: '',
    senderName: '',
    dailyLimit: '500',
  });

  function handleChange(field: keyof typeof form, value: string) {
    setForm(prev => ({ ...prev, [field]: value }));
  }

  const fields: Array<{ key: keyof typeof form; label: string; type?: string | undefined }> = [
    { key: 'smtpHost', label: t('email.smtpHost') },
    { key: 'smtpPort', label: t('email.smtpPort'), type: 'number' },
    { key: 'smtpUser', label: t('email.smtpUser') },
    { key: 'smtpPass', label: t('email.smtpPass'), type: 'password' },
    { key: 'senderEmail', label: t('email.senderEmail'), type: 'email' },
    { key: 'senderName', label: t('email.senderName') },
    { key: 'dailyLimit', label: t('email.dailyLimit'), type: 'number' },
  ];

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">{t('email.smtpSettings')}</h1>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">{t('email.smtpSettings')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {fields.map(f => (
            <div key={f.key}>
              <label className="text-sm font-medium text-foreground">{f.label}</label>
              <Input
                type={f.type ?? 'text'}
                value={form[f.key]}
                onChange={e => handleChange(f.key, e.target.value)}
                placeholder={f.key === 'smtpPass' ? '••••••' : undefined}
                className="mt-1"
              />
            </div>
          ))}

          {/* Elonezet-jeloles: sem a mentes, sem a kapcsolat-teszt nincs bekotve */}
          <div className="text-sm text-amber-600 dark:text-amber-400">
            {t('common.previewOnly')}
          </div>

          {/* Actions */}
          <div className="flex justify-end pt-4 border-t">
            <Button disabled title={t('common.previewOnlyHint')}>
              {t('email.save')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
